import { c as a, cB as r, cM as o, cE as e, insideModal as n, insidePopover as l } from "./ghl-ui.es361.js";
import { fadeInScaleUpTransition as i } from "./ghl-ui.es1276.js";
const s = a([r("slider", `
 display: block;
 padding: calc((var(--n-handle-size) - var(--n-rail-height)) / 2) 0;
 position: relative;
 z-index: 0;
 width: 100%;
 cursor: pointer;
 user-select: none;
 -webkit-user-select: none;
 `, [o("reverse", [r("slider-handles", [r("slider-handle-wrapper", `
 transform: translate(50%, -50%);
 `)]), r("slider-dots", [r("slider-dot", `
 transform: translateX(50%, -50%);
 `)]), o("vertical", [r("slider-handles", [r("slider-handle-wrapper", `
 transform: translate(-50%, -50%);
 `)]), r("slider-marks", [r("slider-mark", `
 transform: translateY(calc(-50% + var(--n-dot-height) / 2));
 `)]), r("slider-dots", [r("slider-dot", `
 transform: translateX(-50%) translateY(0);
 `)])])]), o("vertical", `
 padding: 0 calc((var(--n-handle-size) - var(--n-rail-height)) / 2);
 width: var(--n-rail-width-vertical);
 height: 100%;
 `, [r("slider-handles", `
 top: calc(var(--n-handle-size) / 2);
 right: 0;
 bottom: calc(var(--n-handle-size) / 2);
 left: 0;
 `, [r("slider-handle-wrapper", `
 top: unset;
 left: 50%;
 transform: translate(-50%, 50%);
 `)]), r("slider-rail", `
 height: 100%;
 `, [e("fill", `
 top: unset;
 right: 0;
 bottom: unset;
 left: 0;
 `)]), o("with-mark", `
 width: var(--n-rail-width-vertical);
 margin: 0 32px 0 8px;
 `), r("slider-marks", `
 top: calc(var(--n-handle-size) / 2);
 right: unset;
 bottom: calc(var(--n-handle-size) / 2);
 left: 22px;
 font-size: var(--n-mark-font-size);
 `, [r("slider-mark", `
 transform: translateY(50%);
 white-space: nowrap;
 `)]), r("slider-dots", `
 top: calc(var(--n-handle-size) / 2);
 right: unset;
 bottom: calc(var(--n-handle-size) / 2);
 left: 50%;
 `, [r("slider-dot", `
 transform: translateX(-50%) translateY(50%);
 `)])]), o("disabled", `
 cursor: not-allowed;
 opacity: var(--n-opacity-disabled);
 `, [r("slider-handle", `
 cursor: not-allowed;
 `)]), o("with-mark", `
 width: 100%;
 margin: 8px 0 32px 0;
 `), a("&:hover", [r("slider-rail", {
  backgroundColor: "var(--n-rail-color-hover)"
}, [e("fill", {
  backgroundColor: "var(--n-fill-color-hover)"
})]), r("slider-handle", {
  boxShadow: "var(--n-handle-box-shadow-hover)"
})]), o("active", [r("slider-rail", {
  backgroundColor: "var(--n-rail-color-hover)"
}, [e("fill", {
  backgroundColor: "var(--n-fill-color-hover)"
})]), r("slider-handle", {
  boxShadow: "var(--n-handle-box-shadow-hover)"
})]), r("slider-marks", `
 position: absolute;
 top: 18px;
 left: calc(var(--n-handle-size) / 2);
 right: calc(var(--n-handle-size) / 2);
 `, [r("slider-mark", `
 position: absolute;
 transform: translateX(-50%);
 white-space: nowrap;
 `)]), r("slider-rail", `
 width: 100%;
 position: relative;
 height: var(--n-rail-height);
 background-color: var(--n-rail-color);
 transition: background-color .3s var(--n-bezier);
 border-radius: calc(var(--n-rail-height) / 2);
 `, [e("fill", `
 position: absolute;
 top: 0;
 bottom: 0;
 border-radius: calc(var(--n-rail-height) / 2);
 transition: background-color .3s var(--n-bezier);
 background-color: var(--n-fill-color);
 `)]), r("slider-handles", `
 position: absolute;
 top: 0;
 right: calc(var(--n-handle-size) / 2);
 bottom: 0;
 left: calc(var(--n-handle-size) / 2);
 `, [r("slider-handle-wrapper", `
 outline: none;
 position: absolute;
 top: 50%;
 transform: translate(-50%, -50%);
 cursor: pointer;
 display: flex;
 `, [r("slider-handle", `
 height: var(--n-handle-size);
 width: var(--n-handle-size);
 border-radius: 50%;
 overflow: hidden;
 transition: box-shadow .2s var(--n-bezier), background-color .3s var(--n-bezier);
 background-color: var(--n-handle-color);
 box-shadow: var(--n-handle-box-shadow);
 `, [a("&:hover", `
 box-shadow: var(--n-handle-box-shadow-hover);
 `)]), a("&:focus", [r("slider-handle", `
 box-shadow: var(--n-handle-box-shadow-focus);
 `, [a("&:hover", `
 box-shadow: var(--n-handle-box-shadow-active);
 `)])])])]), r("slider-dots", `
 position: absolute;
 top: 50%;
 left: calc(var(--n-handle-size) / 2);
 right: calc(var(--n-handle-size) / 2);
 `, [o("transition-disabled", [r("slider-dot", "transition: none;")]), r("slider-dot", `
 transition:
 border-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 position: absolute;
 transform: translate(-50%, -50%);
 height: var(--n-dot-height);
 width: var(--n-dot-width);
 border-radius: var(--n-dot-border-radius);
 overflow: hidden;
 box-sizing: border-box;
 border: var(--n-dot-border);
 background-color: var(--n-dot-color);
 `, [o("active", "border: var(--n-dot-border-active);")])])]), r("slider-handle-indicator", `
 font-size: var(--n-font-size);
 padding: 6px 10px;
 border-radius: var(--n-indicator-border-radius);
 color: var(--n-indicator-text-color);
 background-color: var(--n-indicator-color);
 box-shadow: var(--n-indicator-box-shadow);
 `, [i()]), r("slider-handle-indicator", `
 font-size: var(--n-font-size);
 padding: 6px 10px;
 border-radius: var(--n-indicator-border-radius);
 color: var(--n-indicator-text-color);
 background-color: var(--n-indicator-color);
 box-shadow: var(--n-indicator-box-shadow);
 `, [o("top", `
 margin-bottom: 12px;
 `), o("right", `
 margin-left: 12px;
 `), o("bottom", `
 margin-top: 12px;
 `), o("left", `
 margin-right: 12px;
 `), i()]), n(r("slider", [r("slider-dot", "background-color: var(--n-dot-color-modal);")])), l(r("slider", [r("slider-dot", "background-color: var(--n-dot-color-popover);")]))]);
export {
  s as default
};
